import 'react-app-polyfill/ie11';
import 'core-js';
import 'element-closest-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from './app';
import configureStore from "./store/configureStore";
import {Provider} from "react-redux";
import cssVars from "css-vars-ponyfill";
import ieSvg from "./components/icons/ieSvg";
import customization from './static/skin/skin';

import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_INSTANCE !== 'development')
  Sentry.init({
    environment: process.env.REACT_APP_INSTANCE,
    dsn: "https://67493cf617ea42369a05a88212f327f2@rel.faktura.ru/4",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });

const store = configureStore();
customization();
cssVars({
  rootElement: document,
  shadowDOM: false,
  include: 'link[rel=stylesheet],style',
  exclude: '',
});
ieSvg();
var isIexplorer = require('is-iexplorer');
if (isIexplorer) {
  var el = document.querySelector("body");
  el.className += " msie";
}

ReactDOM.render((
  <Provider store={store}>
    <App />
    <div id="preloader"></div>
  </Provider>
  ), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();